import type { CSSProperties } from 'react';

type QuestionContentBadgesProps = {
  isHighFrequency?: boolean;
  isNew?: boolean;
  style?: 'soft' | 'outline';
  locale?: 'zh-CN' | 'en-US';
  className?: string;
};

export function QuestionContentBadges({
  isHighFrequency = false,
  isNew = false,
  style = 'soft',
  locale = 'zh-CN',
  className = '',
}: QuestionContentBadgesProps) {
  if (!isHighFrequency && !isNew) return null;

  const outline = style === 'outline';
  const badgeStyle = (kind: 'featured' | 'new'): CSSProperties => ({
    borderColor: `var(--color-content-${kind})`,
    backgroundColor: outline ? 'transparent' : `var(--color-content-${kind}-light)`,
    color: `var(--color-content-${kind})`,
  });
  const highFrequencyLabel = locale === 'en-US' ? 'High frequency' : '高频';
  const newLabel = locale === 'en-US' ? 'New' : '新增';

  return (
    <span
      className={`inline-flex min-w-0 flex-wrap items-center gap-1.5 ${className}`}
      role="group"
      aria-label={[isHighFrequency ? highFrequencyLabel : '', isNew ? newLabel : ''].filter(Boolean).join(', ')}
    >
      {isHighFrequency ? (
        <span aria-hidden="true" className="inline-flex min-h-5 items-center rounded-[var(--radius-full)] border px-2 text-[11px] font-semibold leading-4" style={badgeStyle('featured')}>
          {highFrequencyLabel}
        </span>
      ) : null}
      {isNew ? (
        <span aria-hidden="true" className="inline-flex min-h-5 items-center rounded-[var(--radius-full)] border px-2 text-[11px] font-semibold leading-4" style={badgeStyle('new')}>
          {newLabel}
        </span>
      ) : null}
    </span>
  );
}
